import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import shortid from 'shortid';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Form from 'react-bootstrap/lib/Form';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';

@inject('mixStore')
@observer
class CloneMixModal extends Component {
  constructor() {
    super();
    this.state = this.getInitialState();
  }

  getInitialState = () => {
    return {
      values: [
        {
          id: shortid.generate(),
          itemId: '',
          itemCode: '',
        },
      ],
    };
  };

  getCurrentMix = () => {
    const { getMixById, selectedId } = this.props.mixStore;
    const selectedMix = getMixById(selectedId);
    if (!selectedMix) {
      return;
    }
    this.setState({
      values: [
        {
          id: shortid.generate(),
          itemId: selectedMix.itemId,
          itemCode: '',
        },
      ],
    });
  };

  addRow = () => {
    this.setState({
      values: [
        ...this.state.values,
        {
          id: shortid.generate(),
          itemId: '',
          itemCode: '',
        },
      ],
    });
  };

  deleteRow = id => {
    this.setState({
      values: this.state.values.filter(v => v.id !== id),
    });
  };

  onChange = (id, field) => e => {
    const index = this.state.values.findIndex(v => v.id === id);
    this.setState({
      values: [
        ...this.state.values.slice(0, index),
        {
          ...this.state.values[index],
          [field]: e.target.value,
        },
        ...this.state.values.slice(index + 1),
      ],
    });
  };

  onSave = () => {
    this.props.mixStore.cloneMixes(this.state.values);
    this.onHide();
  };

  onHide = () => {
    this.setState(this.getInitialState());
    this.props.onHide();
  };

  renderRow = (id, value) => {
    const { mixes, selectedId } = this.props.mixStore;
    return (
      <Row key={id} className={`clone-${selectedId}`}>
        <Col sm={5}>
          <FormGroup>
            <ControlLabel>Mix</ControlLabel>
            <FormControl
              name={`material_${id}`}
              value={value.itemId}
              onChange={this.onChange(id, 'itemId')}
              componentClass="select"
            >
              <option value="">- Select -</option>
              {mixes.map(option => (
                <option key={option.id} value={option.id}>
                  {option.itemCode}
                </option>
              ))}
            </FormControl>
          </FormGroup>
        </Col>
        <Col sm={5}>
          <FormGroup>
            <ControlLabel>New Code</ControlLabel>
            <FormControl
              name={`code_${id}`}
              value={value.itemCode}
              onChange={this.onChange(id, 'itemCode')}
            />
          </FormGroup>
        </Col>
        <Col sm={2}>
          <a className="btn btn-sm btn-default btn-action"
            title="Remove"
            onClick={() => this.deleteRow(id)}>
            <i className="fa fa-remove"/>
          </a>
        </Col>
      </Row>
    );
  };

  renderForm() {
    return (
      <Form onSubmit={this.onSave} className="mix-clone-form">
        {this.state.values.map(row => this.renderRow(row.id, row))}
      </Form>
    );
  }

  render() {
    const { show } = this.props;

    return (
      <Modal show={show} onEntering={this.getCurrentMix} onHide={this.onHide} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>Save New Copy As</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderForm()}
          <Row>
            <Col sm={12}>
              <a className="btn btn-sm btn-default btn-add"
                title="Add mix design" onClick={this.addRow}>
                <i className="fa fa-plus"></i>
              </a>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onHide}>Close</Button>
          &nbsp;&nbsp;
          <Button bsStyle="primary" onClick={this.onSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CloneMixModal;
